
var viewControle = document.getElementsByName('view');
var projectsList = document.getElementById('projects-list');

viewControle.forEach(element => {
    element.addEventListener('change', event => {
    	projectsList.classList.remove('grid', 'list', 'map');
    	projectsList.classList.add(element.value);
    });
});